(function () {
  'use strict';

  var WHEEL_DEBOUNCE = 420;
  var lastWheel = 0;

  function init() {
    if (!document.querySelector('.template-product')) return;

    var gallery = document.querySelector('.m-product-media--desktop');
    if (!gallery) return;
    if (gallery.querySelector('.jc-zone-prev')) return; // already inited

    var btnPrev = gallery.querySelector('.swiper-button-prev');
    var btnNext = gallery.querySelector('.swiper-button-next');

    function goPrev() {
      if (btnPrev) btnPrev.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
    function goNext() {
      if (btnNext) btnNext.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }

    // Invisible left/right click zones
    gallery.style.position = 'relative';

    var zonePrev = document.createElement('div');
    zonePrev.className = 'jc-zone-prev';
    zonePrev.style.cssText = 'position:absolute;top:0;left:0;width:50%;height:100%;z-index:4;cursor:w-resize;';
    zonePrev.addEventListener('click', goPrev);

    var zoneNext = document.createElement('div');
    zoneNext.className = 'jc-zone-next';
    zoneNext.style.cssText = 'position:absolute;top:0;right:0;width:50%;height:100%;z-index:4;cursor:e-resize;';
    zoneNext.addEventListener('click', goNext);

    gallery.appendChild(zonePrev);
    gallery.appendChild(zoneNext);

    // Trackpad horizontal swipe
    gallery.addEventListener('wheel', function (e) {
      var ax = Math.abs(e.deltaX);
      var ay = Math.abs(e.deltaY);
      if (ax > ay && ax > 6) {
        e.preventDefault();
        var now = Date.now();
        if (now - lastWheel > WHEEL_DEBOUNCE) {
          lastWheel = now;
          if (e.deltaX > 0) goNext(); else goPrev();
        }
      }
    }, { passive: false });
  }

  function tryInit() {
    init();
    // Retry if media gallery renders late
    if (!document.querySelector('.m-product-media--desktop .jc-zone-prev')) {
      var attempts = 0;
      var timer = setInterval(function () {
        if (++attempts > 10) { clearInterval(timer); return; }
        init();
        if (document.querySelector('.m-product-media--desktop .jc-zone-prev')) clearInterval(timer);
      }, 350);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInit, 500); });
  } else {
    setTimeout(tryInit, 500);
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(tryInit, 300); });
})();
